<script lang="ts">
    import $ from "jquery";
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { KendoChart } from "@Kendo/Components/KendoChart";

    @Component({
        props: {
            propOpened: { type: Boolean, required: true, default: false },
            propTitle: { type: String, required: false, default: '' },
            propChart: { type: Object, required: false, default: null },
        },
        watch: {
            opened: 'onOpenedChanged'
        }
    })
    export default class KendoChartFullScreenDialog extends Vue
    {
        get opened(): boolean { return this.$props.propOpened; }
        get chart(): KendoGrid { return this.$props.propChart; }
        get title(): string { return this.$props.propTitle; }

        //@Watch('opened')
        onOpenedChanged(val: boolean, oldVal: boolean)
        {
            if (val === true)
            {
                Vue.nextTick(() =>
                {
                    $('#FullScreenChart').kendoChart(this.chart.GetOptions().Get());
                    this.chart.IsFullScreen = true;
                });
            }
            else
            {
                this.chart.IsFullScreen = false;
            }
        }

        close()
        {
            this.$emit('close-dialog');
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable" style="max-width: 96%;">
                <div class="modal-content" style="height: calc(100vh - 5px);">
                    <div class="modal-header">
                        <h5 class="modal-title">{{title}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body" style="height: 100%;">
                        <div id="FullScreenChart" style="height: 100%;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>